module.exports = __webpack_public_path__ + "img/unsettled_icon.5197108d.svg";